import { FC, useState } from 'react';
import { Button, CloseIcon, ConfirmationDialog, YellowWarningIcon } from '@repo/atomic-components';
import { PAGINATOR_INFO_CONFIRM, PAGINATOR_INFO_DISMISSED_KEY } from '@/constants/dialogs';

export const isPaginatorInfoDismissed = () => localStorage.getItem(PAGINATOR_INFO_DISMISSED_KEY) === 'true';

export const PaginatorInfoDialog: FC = () => {
  const [hideNextTime, setHideNextTime] = useState(false);

  return (
    <ConfirmationDialog
      id={PAGINATOR_INFO_CONFIRM}
      style={{ width: '280px', borderRadius: '8px', border: '1px solid #e1e1e0', overflow: 'hidden' }}
      contentClassName="!p-0"
      headerClassName="!hidden"
    >
      {(_params, { accept, reject }) => (
        <div className="relative p-[24px]">
          <button
            type="button"
            aria-label="Close"
            onClick={reject}
            className="absolute top-[24px] right-[24px] cursor-pointer rounded p-1 focus:outline-none"
          >
            <CloseIcon width={12} height={12} />
          </button>
          <div className="mt-[16px] flex flex-col items-center">
            <YellowWarningIcon width={48} height={48} />
            <div className="text-fletchers-black-900 mt-[16px] text-center text-[16px]/[20px] font-semibold">
              Paginator provider
            </div>
          </div>
          <div className="text-fletchers-gray-300 mt-[24px] text-center text-[14px]/[20px]">
            Documents under a Paginator provider won't be AI sorted. They'll appear in their original order in the
            bundle.
          </div>
          <label className="mt-[16px] flex cursor-pointer items-center justify-center gap-2">
            <input
              type="checkbox"
              checked={hideNextTime}
              onChange={(e) => setHideNextTime(e.target.checked)}
              className="accent-fletchers-green-500 h-4 w-4 cursor-pointer"
            />
            <span className="text-fletchers-gray-200 text-[13px]/[18px]">Do not show this again</span>
          </label>
          <div className="mt-[24px] flex gap-[8px]">
            <Button
              outlined
              label="Cancel"
              className="hover:bg-fletchers-gray-110 flex-1"
              onClick={reject}
              style={{ height: '32px', fontSize: '14px', borderRadius: '4px' }}
            />
            <Button
              label="Got it"
              className="flex-1"
              onClick={() => {
                if (hideNextTime) {
                  localStorage.setItem(PAGINATOR_INFO_DISMISSED_KEY, 'true');
                }
                accept();
              }}
              style={{
                height: '32px',
                fontSize: '14px',
                borderRadius: '4px',
                backgroundColor: '#1a7a5b',
                borderColor: '#1a7a5b',
                color: 'white',
              }}
            />
          </div>
        </div>
      )}
    </ConfirmationDialog>
  );
};
